import React, { useContext, useEffect } from 'react'
import PopUpModal from './PopUpModal'
import { ReactComponent as SecurityIcon } from "../assets/icons/SecurePrivate.svg";
import { useState } from 'react';
import { DataContext } from '../Context/DataContext';
import { FormTextInput } from '../Components/FormTextInput';
import { auth, firestore } from '../firebase.config';
import { NotificationContext } from '../Context/NotificationContext';

const ChangePasswordWarning = () => {
    const [showChangePasswordWarning, setShowChangePasswordWarning] = useState(false);
    const [showUpdatePassword, setShowUpdatePassword] = useState(false);
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordError, setPasswordError] = useState(false);
    const [confirmPasswordError, setConfirmPasswordError] = useState(false);
    const {showNotification} = useContext(NotificationContext);

    const [saveBtnText, setSaveBtnText] = useState("Save Password");

    const {userData} = useContext(DataContext);

    useEffect(() => {
        if(userData?.tempCreds) {
            setShowChangePasswordWarning(true);
        }
    }, [userData])

    useEffect(() => {
       if(confirmPassword.length > 0 && confirmPassword !== password) {
        setConfirmPasswordError(true);
       }
    }, [confirmPassword, password])

    const handleNewPassword = (value) => {
        setPasswordError(false);
        setPassword(value);
    };

    const handleConfirmPassword = (value) => {
        setConfirmPasswordError(false);
        setConfirmPassword(value);
    };

    const handlePasswordBlur = () => {
        if (password === "" || password.length < 6) {
            setPasswordError(true);
        }
    };
    const handleConfirmPasswordBlur = () => {
        if (confirmPassword.length > 0 && confirmPassword !== password) {
            setConfirmPasswordError(true);
        }
    };

    const handleUpdatePassword = () => {
        if (password === "" || password.length < 6) {
            setPasswordError(true);
            return;
        }
        if (password !== confirmPassword) {
            setConfirmPasswordError(true);
            return;
        }

        setSaveBtnText("Saving...")

        auth.currentUser.updatePassword(password).then(() => {
            removeTempCred().then(() => {
                setShowUpdatePassword(false);
                setSaveBtnText("Save Password");
                showNotification("Success", "Password updated successfully", "success");
            })
        }).catch((error) => {
            setSaveBtnText("Save Password");
            showNotification("Error", "Error occurred while updating password. Please try again or contact support!", "error");
        })
        
    }

    const removeTempCred = async() => {
        await firestore.collection("users").doc(auth.currentUser.uid).update({
            tempCreds: null,
        }).catch((error) => {
            showNotification("Error", "Error occurred while updating password. Please try again or contact support!", "error");
        })  
    }

    const handleSkip = () => {
        removeTempCred();
        setShowChangePasswordWarning(false);
    }

  return (
    <>
        {showChangePasswordWarning && ( 
        <PopUpModal
        title={"Secure Your Account"}
        backBtnText={userData && userData.createdByInvitation ? "" : "Skip"}
        subText={userData && userData.createdByInvitation ? 
            "We've detected a new account created for you. Please create new password to continue."
            : "We've detected a first-time login with a temporary password. For your security, please update it to a permanent one."}
        btnText={userData && userData.createdByInvitation ? "Create Password" : "Update Password"}
        showClose={userData && userData.createdByInvitation ? false : true}
        onClose={() => {setShowChangePasswordWarning(false) }}
        onClick={(e) => { setShowUpdatePassword(true); setShowChangePasswordWarning(false);}}
        onBackClick={handleSkip}
        >
        <SecurityIcon />
        </PopUpModal>
        )}
        {showUpdatePassword && ( 
        <PopUpModal
        components={
             <div className=" w-full flex flex-col gap-2">
                
                <FormTextInput password showPasswordIcon placeholder={"Password"} incorrect={passwordError} value={password} onBlur={handlePasswordBlur} onChange={handleNewPassword}/>
               
                {passwordError &&
                <span className="text-xs text-red-500">
                    Password must be minimum 6 characters long
                </span>
                }
                <FormTextInput password showPasswordIcon placeholder={"Confirm Password"} incorrect={confirmPasswordError} value={confirmPassword} onChange={handleConfirmPassword}/>
            
                {confirmPasswordError && <span className='text-xs text-red-500'>Passwords Don't Match</span>}
                
             </div>
        }
        contentFullWidth
        title={"Update Password"}
        btnText={saveBtnText}
        showClose
        onClose={() => {setShowUpdatePassword(false) }}
        onClick={(e) => {handleUpdatePassword() }}
        onBackClick={() => {setShowUpdatePassword(false); }}
        hideIcon
        disableBtn={saveBtnText === "Saving..." ||confirmPasswordError || passwordError || password === "" || confirmPassword === "" || password !== confirmPassword}
        >
        </PopUpModal>
        )}
    </>
  )
}

export default ChangePasswordWarning